
<div class="overlay-container" >
</div> 
<div class="modal show" id="myModal" >
 <div class="modal-dialog modal-lg">
    <div class="modal-content modal-bg">
      <!-- Modal body -->
      <div class="modal-body">
        <button type="button" class="close popupClose" data-dismiss="modal" (click)="close()"><img src="{{globalService.staticResourceURL}}/assets/images/Icon-icon-placeholder.svg" class="img-fluid"></button>
      
       
          
            <div class="row no-margin pt-1">
                <div class="col-12 col-sm-12 mb-3" [innerHTML]="privacyPolicy">
                    
                </div>
                  
                
              
                  
                        
                      
                     
              </div>          
        </div>

    </div>
  </div>
</div>